"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: false,
        defaultValue: 'inputformula',
    },
    {
        type: 'checkbox',
        key: 'showCode',
        label: 'Show Code',
        input: true,
        weight: 99,
        defaultValue: true,
        tooltip: 'Show code in the input.',
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: false
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        type: 'select',
        key: 'align',
        label: 'Align',
        input: true,
        dataSrc: 'values',
        weight: 100,
        tooltip: 'Align.',
        data: {
            values: [
                { label: 'Left', value: 'justify-content-start' },
                { label: 'Center', value: 'justify-content-center' },
                { label: 'Right', value: 'justify-content-end' },
                { label: 'Full', value: 'justify-content-between' }
            ],
        },
    },
    {
        type: 'textarea',
        key: 'custom',
        label: 'Button Custom Logic',
        tooltip: 'The custom logic to evaluate when the button is clicked.',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 103,
        placeholder: "data['mykey'] = data['anotherKey'];",
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'custom'] },
        },
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'theme',
        label: 'Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of buttons.',
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'themeActive',
        label: 'Active Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of Active button.',
    },
];
